var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "read-more", class: { ..._vm.wrapperClass } },
    [
      _c("div", {
        staticClass: "read-more__content",
        style: _vm.contentStyle,
        domProps: { innerHTML: _vm._s(_vm.content) },
      }),
      _vm._v(" "),
      _vm.isNeeded
        ? _c(
            "button",
            {
              staticClass: "read-more__button",
              on: { click: _vm.handleToggle },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.isOpen ? "Read less" : "Read More") +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }